/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Configuration for system prompt leakage detection guardrail
 */
export type LeakageConfig = {
  /**
   * Detection threshold (0-1)
   */
  threshold?: number | undefined;
  /**
   * The message to return when this guardrail is triggered
   */
  rejectionMessage?: string | undefined;
};

/** @internal */
export const LeakageConfig$inboundSchema: z.ZodType<
  LeakageConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  threshold: z.number().default(0.7),
  rejection_message: z.string().default(
    "I'm sorry, but I can't help with that type of request. Please ask me something else.",
  ),
}).transform((v) => {
  return remap$(v, {
    "rejection_message": "rejectionMessage",
  });
});
/** @internal */
export type LeakageConfig$Outbound = {
  threshold: number;
  rejection_message: string;
};

/** @internal */
export const LeakageConfig$outboundSchema: z.ZodType<
  LeakageConfig$Outbound,
  z.ZodTypeDef,
  LeakageConfig
> = z.object({
  threshold: z.number().default(0.7),
  rejectionMessage: z.string().default(
    "I'm sorry, but I can't help with that type of request. Please ask me something else.",
  ),
}).transform((v) => {
  return remap$(v, {
    rejectionMessage: "rejection_message",
  });
});

export function leakageConfigToJSON(leakageConfig: LeakageConfig): string {
  return JSON.stringify(LeakageConfig$outboundSchema.parse(leakageConfig));
}
export function leakageConfigFromJSON(
  jsonString: string,
): SafeParseResult<LeakageConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => LeakageConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'LeakageConfig' from JSON`,
  );
}
